<div class="description-producer">
  <div class="top-part">
    <div class="header">
      <label class="name" *ngIf="!isEditMode">{{ data?.name }}</label>
      <input *ngIf="isEditMode" class="name-input" [(ngModel)]="data.name" maxlength="250" />
    </div>
    <label class="wattage" *ngIf="!isEditMode">{{ data?.unitPerformance }}</label>
    <input *ngIf="isEditMode" class="name-input" [(ngModel)]="data.unitPerformance" />
    <button type="button" class="btn btn-primary" id="edit-name" (click)="isEditMode = true" *ngIf="!isEditMode">
      <span class="fa fa-pencil-square-o" aria-hidden="true" id="edit-icon"></span>
      <span class="btn-text">Name bearbeiten</span>
    </button>
    <button (click)="save()" *ngIf="isEditMode" class="btn save-btn">
      <span class="fa fa-check-circle-o" aria-hidden="true"></span>
      <span class="btn-text">Save</span>
    </button>
  </div>

  <p class="description" *ngIf="!isEditMode">
    {{ data?.description }}
  </p>
  <textarea class="description-input" rows="5" cols="50" *ngIf="isEditMode" [(ngModel)]="data.description" maxlength="250"> </textarea>

  <div class="bottom-part">
    <div class="options" *ngIf="data.name !== null && data.name.trim() !== ''">
      <button type="button" class="btn btn-primary -border" (click)="showQuestionnaire()">
        {{ 'module.energyMap.descriptionComponent.navigationTargetPerformanceComparisonText' | translate }}
      </button>
      <button type="button" class="btn btn-white -border">
        {{ 'module.energyMap.descriptionComponent.navigationEnergyVisualizatonText' | translate }}
      </button>
    </div>
  </div>
</div>
<app-performance-questionnaire
  [alignment]="data.orientation"
  [tiltAngle]="data.inclinationi"
  *ngIf="isQuestionnaireVisible"
  [visibility]="isQuestionnaireVisible"
  (closeEvent)="isQuestionnaireVisible = false; isModalVisible = false; isBenchmarkingVisible = true"
></app-performance-questionnaire>
